export default __webpack_public_path__ + "static/media/scotland.e6b522dc.png";